import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';

const Notification = ({ message, type = 'success', duration = 5000, onClose }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message && message.trim() !== '') {
      setOpen(true);
      const timer = setTimeout(() => {
        setOpen(false);
        if (onClose) onClose();
      }, duration);

      return () => clearTimeout(timer);
    } else {
      setOpen(false);
    }
  }, [message, duration, onClose]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    if (onClose) onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        onClose={handleClose} 
        severity={type} 
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
